import React, { Component } from 'react';
import styles from './Spinner.scss';
import classNames from 'classnames';

class Spinner extends Component {
	render() {
		return (
			<React.Fragment>
				<svg
					className={classNames(styles.Spinner, this.props.className)}
					viewBox="0 0 66 66"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle
						className={classNames(styles.Path, this.props.className)}
						fill="none"
						strokeWidth="4"
						strokeLinecap="round"
						cx="33"
						cy="33"
						r="30"
					/>
				</svg>
				<div className={styles.LoadContainer}>
					<div
						className={classNames(styles.LoadZenith, this.props.IEStyle)}
					/>
				</div>
			</React.Fragment>
		);
	}
}

export default Spinner;
